import React from 'react';
import UI from '../ui';
import { RateCallStatus } from './RateCallStatus.enum';

const { WrappedButton, WrappedButtonType } = UI;

const ValidationError = ({ type, onRetryButtonClick }) => (
	<div className="common-rate-advisor-validation-error">
		{type === RateCallStatus.NoData && (
			<div className="no-data-error-container">
				<p className="content">No services are available for this shipment.</p>
				<br />
				<p className="content">Adjust one or more of the following:</p>
				<br />
				<ul className="sub-content-error">
					<li>Weight</li>
					<li>Dimensions</li>
					<li>Filters</li>
				</ul>
			</div>
		)}

		{type === RateCallStatus.Error && (
			<div className="generic-error-container">
				<p className="content">Unable to load results.</p>
				<p className="sub-content-error">An unexpected error occurred.</p>
				<WrappedButton
					buttonType={WrappedButtonType.Primary}
					label="Retry"
					onClick={onRetryButtonClick}
					dataqa="validation-retry"
				/>
			</div>
		)}
	</div>
);

export default ValidationError;
